import { Component } from '@angular/core';
import { UrlService } from '../../../services/url.service';
import { WebsiteBuilderService } from '../../../services/website-builder.service';
import { IWebsiteBuilder } from '../../../types/api-response/auth/website-builder';

@Component({
    selector: 'corporations-list',
    templateUrl: './corporations-list.component.html',
    styleUrls: ['./corporations-list.component.scss']
})
export class CorporationsListComponent {

    constructor(
        public urlService: UrlService,
        public websiteBuilderService: WebsiteBuilderService
    ) {
    }

    orderBy(orderBy: string, $event) {
        if (this.websiteBuilderService.data.corporations.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    toggleCheck(selectedItem: IWebsiteBuilder): void {
        this.uncheckItem();

        if (selectedItem.checked && this.websiteBuilderService.selectedItemData) {
            this.websiteBuilderService.chosenCorporation = null;
            this.websiteBuilderService.toggleDetailedView(null, false);
        } else {
            this.websiteBuilderService.chosenCorporation = selectedItem.corporationNumberId;
            selectedItem.checked = true;
            // get website builder settings for corporation before toggling
            this.websiteBuilderService.toggleDetailedView(selectedItem, true);
        }
    }

    uncheckItem(): void {
        this.websiteBuilderService.data.corporations.data.forEach((item) => item.checked = false);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/corporations-list/corporations-list.component.ts